import React from "react";
import styled from "styled-components";
import { Modal } from "../../../../../../app/components";
import Typography from "@material-ui/core/Typography";
import PrimaryButton from "../../../../../../app/components/buttons/primary";
import OutlinedButton from "../../../../../../app/components/buttons/outlined";

const SaveAsModal = ({
  open = false,
  onClose = (noop) => noop,
  onConfirm,
  plan,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby={`Save as a Draft`}
      aria-describedby={`Save as a Draft`}
      title={`Save As Draft`}
    >
      <Container>
        <Typography>This study plan draft will be saved as: </Typography>
        <Typography>
          <strong>{`${plan.studyPlanName} - V${
            plan.studyPlanVersion + 1
          }`}</strong>
        </Typography>
        <SideBySide>
          <OutlinedButton onClick={onClose}>Cancel</OutlinedButton>
          <PrimaryButton onClick={onConfirm}>Save Draft</PrimaryButton>
        </SideBySide>
      </Container>
    </Modal>
  );
};

export default SaveAsModal;

const Container = styled.div`
  display: grid;
  grid-gap: 2em;
`;

const SideBySide = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1em;
`;
